import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { IReportFilter } from '../../../utils/interfaces/report-filter';
import { IResponse } from '../../../utils/interfaces/response';

@Injectable({
  providedIn: 'root',
})
export class AggregatedReportService {
  private readonly URI_API = environment.apiConfig.uri + 'AggregatedReport';

  constructor(private readonly httpClient: HttpClient) {
  }

  getAggregatedReport(filter: IReportFilter): Observable<IResponse<unknown>> {
    return this.httpClient.post<IResponse<unknown>>(
      `${this.URI_API}/aggregated`,
      filter,
    );
  }

  getAggregatedByDevices(filter: IReportFilter): Observable<IResponse<unknown>> {
    return this.httpClient.post<IResponse<unknown>>(
      `${this.URI_API}/aggregatedByDevices`,
      filter,
    );
  }

  getAggregatedByDevicesAndShifts(
    filter: IReportFilter,
  ): Observable<IResponse<unknown>> {
    return this.httpClient.post<IResponse<unknown>>(
      `${this.URI_API}/aggregatedByDevicesAndShifts`,
      filter,
    );
  }
}
